import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

import { captureException } from "@sentry/react";

interface Props {
  toPriceId: string;
}

export const upgradeSubscription = createAsyncThunk<void, Props, ThunkConfig<ApiError>>(
  "subscription/upgradeSubscription",
  async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      await extra.api.post("/api/subscription/upgrade_subscription", params);
    } catch (err) {
      captureException(err);

      return rejectWithValue(handleError(err));
    }
  }
);
